export default "__VITE_ASSET__1cd2e664__"